import { SIM_BUILDER_API_END_POINT } from "../Config";
import tokenManager from "../utils/tokenManager";
import HttpService from "./HttpService";

const CoachingService = () => {
  const getWebSocketUrl = (sessionId) => {
    const wsBase = SIM_BUILDER_API_END_POINT.replace(/\/api\/?$/, "").replace(
      /^https/,
      "wss"
    ).replace(/^http/, "ws");
    return `${wsBase}/ws/coaching/${sessionId}`;
  };

  return Object.freeze({
    createOrResumeSession: async (payload) => {
      const response = await HttpService().postRequest(payload, "/coaching/session");
      return response;
    },
    getSummary: async (sessionId) => {
      const response = await HttpService().getRequest(null, `/coaching/summary/${sessionId}`);
      return response;
    },
    createLiveAvatarToken: async (coachingSessionId) => {
      const token = tokenManager.getToken() || "";
      const response = await HttpService().postRequestWithAuthentication(
        { coachingSessionId },
        "/coaching/liveavatar/token",
        token
      );
      return response;
    },
    stopLiveAvatarSession: async (coachingSessionId) => {
      const token = tokenManager.getToken() || "";
      const response = await HttpService().postRequestWithAuthentication(
        { coachingSessionId },
        "/coaching/liveavatar/stop",
        token
      );
      return response;
    },
    /** Best-effort stop that can outlive page unload (tab close). */
    stopLiveAvatarSessionKeepalive: (coachingSessionId) => {
      if (!coachingSessionId || !SIM_BUILDER_API_END_POINT) {
        return;
      }
      const token = tokenManager.getToken() || "";
      fetch(`${SIM_BUILDER_API_END_POINT}/coaching/liveavatar/stop`, {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ coachingSessionId }),
      }).catch(() => {});
    },
    getWebSocketUrl,
  });
};

export default CoachingService;
